<template>
    <b-form-group :state="state"
                  :label="label"
                  :description="description">
        <slot name="above"></slot>
        <slot></slot>
        <slot name="feedback">
            <b-form-invalid-feedback v-text="error"
                                     v-if="error"/>
        </slot>
        <slot name="below"></slot>
    </b-form-group>
</template>

<script>
    export default {
        props: ['error', 'state', 'label', 'description']
    }
</script>